import React from 'react';
import {Box, IconButton, Typography, useTheme} from '@mui/material';
import {Facebook, Instagram, YouTube} from '@mui/icons-material';
import Grid from "@mui/material/Grid2";
import {Link, useLocation, useNavigate} from "react-router";
import {Trans} from "react-i18next";
import NTPLogo from 'ntp-logo-react';

let pages = ['terms', 'contact', 'privacy', 'return'];
let links = {
    terms: '/terms-and-conditions',
    contact: '/contact',
    privacy: '/privacy-policy',
    'return': '/return-policy'
};
const hideFooterForPaths = ['/sign-in', '/sign-up'];

const Footer = () => {
    const theme = useTheme();

    const {pathname} = useLocation();

    const showHeader = () => {
        return hideFooterForPaths.indexOf(pathname) === -1;
    };

    return (showHeader() &&
        <Box
            sx={{
                backgroundColor: 'secondary.dark',
                color: 'white',
                padding: '15px 20px',
                marginTop: '40px',
                textAlign: 'center',
            }}
        >
            <Grid container spacing={3} justifyContent='center'>

                {/* Left Section */}
                <Grid size={{xs: 12, sm: 4}}>

                    <Box sx={{marginTop: '30px', fontSize: '0.875rem'}}>
                        <Typography variant="body2">
                            &copy; <Trans i18nKey={`legal.copyright`}/>
                        </Typography>
                    </Box>
                    <Grid container spacing={3} justifyContent={"center"} sx={{pt: 5}}>
                        <Link to="https://reclamatiisal.anpc.ro/">
                            <img
                                width="250"
                                alt="anpc-sal"
                                src="https://app-umouh6skwq-lz.a.run.app/dep/siteMedia%2Fanpc-sal.png"
                            />
                        </Link>
                        <Link to="https://ec.europa.eu/consumers/odr">
                            <img
                                width="250"
                                alt="anpc-sol"
                                src="https://app-umouh6skwq-lz.a.run.app/dep/siteMedia%2Fanpc-sol.png"
                            />
                        </Link>
                    </Grid>
                </Grid>
                {/* Center Section */}
                <Grid size={{xs: 12, sm: 4}}>
                    <Typography variant="h6" gutterBottom>
                        <Trans i18nKey={`footer.quickLinks`}>Quick Links</Trans>
                    </Typography>
                    <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                        {pages.map(page => <Link to={links[page]} key={page}
                                                 style={{textDecoration: 'none', color: 'inherit'}}>
                            <Typography variant="caption">
                                <Trans i18nKey={`footer.links.${page}`}/>
                            </Typography>
                        </Link>)}
                    </Box>
                </Grid>

                {/* Right Section */}
                <Grid size={{xs: 12, sm: 4}}>
                    <Typography variant="h6" gutterBottom>
                        <Trans i18nKey={`footer.followUs`}>Follow Us</Trans>
                    </Typography>
                    <Box sx={{display: 'flex', justifyContent: 'center', gap: 2}}>
                        <IconButton href="https://www.instagram.com/diwi.ro" color="inherit"
                                    sx={{'&:hover': {color: '#1DA1F2'}}}>
                            <Instagram/>
                        </IconButton>
                        <IconButton href="https://www.youtube.com/@DreamItWearIt" color="inherit"
                                    sx={{'&:hover': {color: '#0077b5'}}}>
                            <YouTube/>
                        </IconButton>
                        <IconButton href="https://www.facebook.com/profile.php?id=61574477820778" color="inherit"
                                    sx={{'&:hover': {color: '#1DA1F2'}}}>
                            <Facebook/>
                        </IconButton>
                    </Box>
                    <Grid container spacing={3} justifyContent={"center"} sx={{pt: 3}}>
                        <NTPLogo color={theme.palette.secondary.dark} version="orizontal" secret="148502"/>
                    </Grid>
                </Grid>
            </Grid>

        </Box>
    );
};

export default Footer;
